import React from "react";
import { GameState } from "types";
import East from "../PlayerInfo/East";
import North from "../PlayerInfo/North";
import South from "../PlayerInfo/South";
import West from "../PlayerInfo/West";
import PlayHistory from "../PlayerInterface/PlayHistory";

interface Props {
  gameState: GameState;
  users:any;
}

const SpectatorView: React.FC<Props> = ({ gameState, users }) => {
  const { playerIds, players, host, startGame } = gameState;
  return (
    <div className="flex flex-col items-center overflow-hidden xl:overflow-visible">
      {playerIds.length > 1 && playerIds[1] && (
        <North spectator players={players} clientId={playerIds[1]} host={host} gameState={gameState}
        users={users}/>
      )}
      <div className="flex w-full">
        {playerIds.length > 0 && playerIds[0] && (
          <West spectator players={players} clientId={playerIds[0]} host={host} gameState={gameState}
          users={users}/>
        )}
        <div className="flex-grow mt-16">
          {startGame && (
            <PlayHistory
            gameState={gameState}
              playHistory={gameState.playHistory}
              players={players}
            />
          )}
        </div>
        {playerIds.length > 2 && playerIds[2] && (
          <East spectator players={players} clientId={playerIds[2]} host={host} gameState={gameState}
          users={users}/>
        )}
      </div>
      {playerIds.length > 3 && playerIds[3] && (
        <South spectator players={players} clientId={playerIds[3]} host={host} gameState={gameState}
        users={users}/>
      )}
    </div>
  );
};

export default SpectatorView;
